export default {
  app_logo: "/logo-uce.png",
  app_title: "UCE Contabilidad",
  app_description:
    "A cutting-edge accounting application featuring automated processes and a modular, feature-driven architecture for enhanced flexibility and scalability.",
};
